/* Conquest refresh: working vehicle finder, copy fixes, quantity fix, menu categories, stuck-loader cleanup. */
(function () {
  var MAKE_TERMS = { 'GM / Chevrolet': 'Chevrolet', 'Ram / Dodge': 'Dodge', 'Jeep / Chrysler': 'Jeep' };

  /* The fitment pop-up (inline in the product template) always adds quantity 1.
     Make it use the quantity the customer chose on the product form. */
  (function () {
    var orig = URLSearchParams.prototype.set;
    URLSearchParams.prototype.set = function (k, v) {
      if (k === 'quantity' && location.pathname.indexOf('/products/') === 0) {
        var q = document.querySelector('form.js-product-form-main input[name="quantity"]');
        var n = q ? parseInt(q.value, 10) : 0;
        if (n > 0) v = String(n);
      }
      return orig.call(this, k, v);
    };
  })();

  function finder() {
    var year = document.getElementById('cq-year');
    var make = document.getElementById('cq-make');
    var model = document.getElementById('cq-model');
    var trim = document.getElementById('cq-trim');
    var btn = document.querySelector('.cq-vs-btn');
    var row = document.querySelector('.cq-vs-row');
    if (!year || !make || !btn || !row || document.getElementById('cq-kw')) return;
    var maxYear = new Date().getFullYear() + 1;
    var first = year.options[1] ? parseInt(year.options[1].value, 10) : 0;
    for (var y = maxYear; y > first; y--) {
      var o = document.createElement('option'); o.value = y; o.textContent = y;
      year.insertBefore(o, year.options[1]);
    }
    if (model) model.remove();
    if (trim) trim.remove();
    var kw = document.createElement('input');
    kw.type = 'search'; kw.id = 'cq-kw'; kw.className = 'cq-vs-kw';
    kw.placeholder = 'Model or part (e.g. Accord, steering wheel switch)';
    kw.setAttribute('aria-label', 'Model or part');
    row.insertBefore(kw, btn);
    row.classList.add('cq-vs-row--v2');
    var msg = document.createElement('div');
    msg.className = 'cq-vs-msg'; msg.setAttribute('role', 'status'); msg.hidden = true;
    row.appendChild(msg);
    window.cqFindParts = function () {
      var parts = [];
      if (year.value) parts.push(year.value);
      if (make.value) parts.push(MAKE_TERMS[make.value] || make.value);
      if (kw.value.trim()) parts.push(kw.value.trim());
      if (!parts.length) {
        msg.textContent = 'Pick a year and make, or type a part or part number.';
        msg.hidden = false; return;
      }
      window.location.href = '/search?type=product&q=' + encodeURIComponent(parts.join(' '));
    };
    btn.onclick = window.cqFindParts;
    kw.addEventListener('keydown', function (e) { if (e.key === 'Enter') window.cqFindParts(); });
  }
  function copy() {
    var box = document.querySelector('.cq-review-box');
    if (box) box.style.display = 'none';
    var num = document.querySelectorAll('.cq-astat-num');
    for (var i = 0; i < num.length; i++) {
      if (num[i].textContent.trim() === 'Same Day') {
        num[i].textContent = 'Fast';
        var lab = num[i].nextElementSibling;
        if (lab) lab.textContent = 'UPS Shipping';
      }
    }
    var body = document.querySelector('.cq-about-body');
    if (body) {
      body.textContent = body.textContent.replace('shipped the same or next business day', 'shipped fast via UPS');
    }
  }
  /* Google Reviews app was removed: drop the static Google rating callouts. */
  function ratings() {
    var items = document.querySelectorAll('.cq-trust-item, .cq-stat, .cq-astat');
    for (var i = 0; i < items.length; i++) {
      if (/google rating/i.test(items[i].textContent)) {
        var p = items[i].parentElement;
        items[i].remove();
        if (p && p.classList.contains('cq-stats-inner')) {
          p.style.gridTemplateColumns = 'repeat(auto-fit,minmax(100px,1fr))';
        }
      }
    }
  }
  /* Menu: add Shop All Parts everywhere, and the part categories in the phone menu. */
  function menu() {
    var ul = document.querySelector('.main-nav');
    if (!ul || ul.getAttribute('data-cq-menu')) return;
    ul.setAttribute('data-cq-menu', '1');
    var st = document.createElement('style');
    st.textContent = '@media (min-width:769px){.main-nav .cq-mob-only{display:none!important}}';
    document.head.appendChild(st);
    var links = [
      ['Shop All Parts', '/collections/all', false],
      ['Diesel Parts', '/collections/diesel-parts', true],
      ['A/C & Heat', '/collections/a-c-heat-parts', true],
      ['Bumper Parts', '/collections/bumper-parts', true],
      ['Cooling', '/collections/cooling', true],
      ['Exterior', '/collections/exterior', true],
      ['Interior Trim', '/collections/interior-1', true],
      ['License Plate', '/collections/license-plate-bracket', true],
      ['Running Boards', '/collections/running-board', true],
      ['Steering Wheel Switches', '/collections/steering-wheel-switches', true]
    ];
    var first = ul.firstElementChild;
    links.forEach(function (l) {
      var li = document.createElement('li');
      if (l[2]) li.className = 'cq-mob-only';
      var row = document.createElement('div');
      row.className = 'main-nav__row main-nav__row--leaf';
      var a = document.createElement('a');
      a.className = 'main-nav__item--primary';
      a.href = l[1];
      a.textContent = l[0];
      row.appendChild(a); li.appendChild(row);
      ul.insertBefore(li, first);
    });
  }
  function loaders() {
    setTimeout(function () {
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.trim() === 'Loading...' && n.parentElement && n.parentElement.children.length === 0 &&
            !n.parentElement.closest('[aria-live],[role=status],script,style') &&
            !n.parentElement.classList.contains('visually-hidden')) {
          n.parentElement.style.display = 'none';
        }
      }
    }, 4000);
  }
  function init() { finder(); copy(); ratings(); menu(); loaders(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
